module.exports = __webpack_public_path__ + "gamecode/img/yysj_favicon.png?72dcf03f";